export const BASE_URL = 'https://api.srdevops.in:5700/' + 'api/v1/'

export const API_GET_HOME_DATA = BASE_URL + 'home'
export const API_GET_ALL_BLOGS = BASE_URL + 'blog'
export const API_GET_ALL_PROJECTS = BASE_URL + 'projects'
export const API_SEND_QUERY = BASE_URL + 'send-query'